var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 37,
    viewBox: "0 0 32 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9906 1L26.6031 11.0375C28.7019 13.0213 30.1315 15.5492 30.7111 18.3016C31.2906 21.0539 30.9942 23.907 29.8591 26.4999C28.7241 29.0928 26.8015 31.3092 24.3346 32.8685C21.8676 34.4278 18.9671 35.2601 16 35.2601C13.0329 35.2601 10.1324 34.4278 7.66543 32.8685C5.19848 31.3092 3.2759 29.0928 2.14087 26.4999C1.00585 23.907 0.709372 21.0539 1.28895 18.3016C1.86852 15.5492 3.29811 13.0213 5.39688 11.0375L15.9906 1Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFill);
export default __webpack_public_path__ + "static/media/Logo_fill.e1e1c752e98aade1113cf7a7992fa1b7.svg";
export { ForwardRef as ReactComponent };